import { React, useState } from "react";
import Contact from "../contact/contact.js";
import "./main.css";
import Calendar from "../calendar/calendar.js";

export default function MainPage() {
  const CONTACT_MESSAGE =
    "If you would like to avail any of the services offered, or if you have any questions, please fill out the form below to send me an email. I will respond as soon as possible.";

  const [isHidden, setIsHidden] = useState(true);

  const [selectedDate, setSelectedDate] = useState(null);
  const [availableTimeRanges, setAvailableTimeRanges] = useState([]);

  // add function to show availability booking

  function toggleCalendar() {
    setIsHidden(!isHidden);
  }

  return (
    <div id="top" className="main">
      <section className="heading">
        <h1>Notary Services</h1>
        <sub>Notarization | Affidavits | Drafting Assistance</sub>
      </section>
      <div className="column">
        <div className="d-col">
          <div className="row d-row">
            <section className="bio">
              <h2>Zyma Dequit</h2>
              <sub>Licensed Paralegal & Notary Public</sub>
            </section>
            <section className="upcoming-availability desktop-view">
              {/* below is shown as default, when calendar is clicked, it changes the contents to the available times*/}
            </section>
          </div>
          <div className="row d-row">
            <section id="check-availability" className="availability">
              <div className="mobile-view">
                <button
                  className="btn-small availability-btn"
                  onClick={toggleCalendar}
                >
                  {isHidden ? "Check My Availability" : "Hide Calendar"}
                </button>
                <div className={`calendar ${isHidden ? "hidden" : "fade-in"}`}>
                  <Calendar></Calendar>
                </div>
              </div>
              <div className="desktop-view">
                <h2>Availability Calendar</h2>
                <Calendar></Calendar>
              </div>
            </section>
          </div>
        </div>
        <div className="row">
          <section id="contact">
            <Contact></Contact>
          </section>
        </div>
      </div>
    </div>
  );
}

// import { React, useState } from "react";
// import Contact from "../contact/contact.js";
// import "./main.css";
// import Calendar from "../calendar/calendar.js";
// import Availability from "../availability/availability.js";

// export default function MainPage() {
//   const CONTACT_MESSAGE =
//     "If you would like to avail any of the services offered, or if you have any questions, please fill out the form below to send me an email. I will respond as soon as possible.";

//   const [isHidden, setIsHidden] = useState(true);

//   const [selectedDate, setSelectedDate] = useState(null);
//   const [availableTimeRanges, setAvailableTimeRanges] = useState([]);
//   const [upcomingAvailability, setUpcomingAvailability] = useState([]);

//   function toggleCalendar() {
//     setIsHidden(!isHidden);
//     if (!isHidden) {
//       setSelectedDate(null);
//     }
//   }

//   return (
//     <div id="top" className="main">
//       <section className="heading">
//         <h1>Notary Services</h1>
//         <sub>Notarization | Affidavits | Drafting Assistance</sub>
//       </section>
//       <div className="column">
//         <div className="d-col">
//           <div className="row d-row">
//             <section className="bio">
//               <sub>Licensed Paralegal & Notary Public</sub>
//             </section>
//             <section className="upcoming-availability desktop-view">
//               {/* below is shown as default, when calendar is clicked, it changes the contents to the available times*/}
//               <Availability
//                 selectedDate={selectedDate}
//                 availableTimeRanges={availableTimeRanges}
//                 upcomingAvailability={upcomingAvailability}
//               ></Availability>
//             </section>
//           </div>
//           <div className="row d-row">
//             <section id="check-availability" className="availability">
//               <div className="mobile-view">
//                 <Availability
//                   selectedDate={selectedDate}
//                   availableTimeRanges={availableTimeRanges}
//                   upcomingAvailability={upcomingAvailability}
//                 ></Availability>
//                 <button
//                   className="btn-small availability-btn"
//                   onClick={toggleCalendar}
//                 >
//                   {isHidden ? "See More Dates" : "Hide Calendar"}
//                 </button>
//                 <div className={`calendar ${isHidden ? "hidden" : ""}`}>
//                   <Calendar
//                     onSelectDate={setSelectedDate}
//                     onAvailabilityChange={setAvailableTimeRanges}
//                     onUpcomingAvailabilityChange={setUpcomingAvailability}
//                     selectedDate={selectedDate}
//                   ></Calendar>
//                 </div>
//               </div>
//               <div className="desktop-view">
//                 <h2>Availability Calendar</h2>{" "}
//                 <Calendar
//                   onSelectDate={setSelectedDate}
//                   onAvailabilityChange={setAvailableTimeRanges}
//                   onUpcomingAvailabilityChange={setUpcomingAvailability}
//                   selectedDate={selectedDate}
//                 ></Calendar>
//               </div>
//             </section>
//           </div>
//         </div>
//         <div className="row">
//           <section id="contact">
//             <Contact></Contact>
//           </section>
//         </div>
//       </div>
//     </div>
//   );
// }
